import cx from "classnames";
import React, { Suspense, useEffect, useState } from "react";
import { Remarkable } from "remarkable";
import TurndownService from "turndown";
import { useToast } from "../../../../hooks/use-toast.hook";
import { Button, Loader } from "../../../../_components";
import { CloseButton } from "../../../../_components/activity/close-button.component";
import I18 from "../../../../_components/atoms/i18";
import TextButton from "../../../../_components/atoms/text-button";
import { FileInput } from "../../../../_components/form-controls/file-input";
import ModalForm from "../../../../_components/model2";
import AlertStrip from "../../../../_components/molecule/alert-strips";
import Label from "../../../../_components/typography/label.typography";
import UIcon from "../../../../_components/uicon-component";
import UploadProgressBar from "../../../../_components/upload-progress-bar.component";
import { CourseService } from "../../../../_service";
import Validator from "../../../../_utils/validator";
import AddLessonContentComponent from "../../course-detail/course-add-section/add-Lesson-content.component";
import { LessonState } from "../course-view.page";
const RichTextEditor = React.lazy(
  () =>
    import("../../../../_components/form-controls/rich-text-editor.component")
);
const tds = new TurndownService();

/**
 * Render lesson content
 * @param {*} param0
 * @returns
 */

export function LessonSummaryEdit({
  community,
  course,
  section,
  lesson,
  updateSection,
  isLoading,
}) {
  const { addToast, ToastTypes } = useToast();
  const [IsSavingLesson, setIsSavingLesson] = useState(false);
  const [IsPublishing, setIsPublishing] = useState(false);
  const [coverMediaUploadPercent, setCoverMediaUpload] = useState(0);
  const [embedded, setEmbedded] = useState();
  const [embeddedUrl, setEmbeddedUrl] = useState();
  const [content, setContent] = useState();
  const [createContent, setCreateContent] = useState();
  const [contentUrl, setContentUrl] = useState();
  const [description, setDescription] = useState("");
  const isPublished = lesson?.state === LessonState.published;
  /** Initialize contentUrl and description */
  useEffect(() => {
    if (lesson.coverMedia) {
      setContentUrl(lesson.coverMedia);
      setEmbeddedUrl(lesson.coverMedia);
    } else {
      setContentUrl(null);
      setEmbeddedUrl(null);
    }

    const md = new Remarkable();
    setDescription(md.render(lesson.description));
    setContent(null);
    setEmbedded(null);
  }, [lesson]);

  function getPlainDescription(description) {
    if (!description) return "";
    const embeddedDescription = description.replace(
      /(?:<figure class="media"><oembed url=")([^"^<^>^\[^\]]+)(?:"><\/oembed><\/figure>)/g,
      " $1 "
    );

    return tds.turndown(embeddedDescription);
  }

  //  UPDATE LESSON DESCRIPTION
  const updateLessonDescription = (description) => {
    const plainDescription = getPlainDescription(description);
    setIsSavingLesson(true);
    const Payload = {
      ...lesson,
      description: plainDescription,
    };
    CourseService.createLesson(
      community.id,
      course.id,
      section.id,
      Payload,
      lesson.id
    )
      .then(async ({ lesson }) => {
        await uploadCoverMedia(lesson, (lesson) => {
          updateLesson(lesson);
          addToast(
            "Success",
            "Lesson updated successfully!",
            ToastTypes.success
          );
        });
      })
      .catch((error) => {
        console.error(error);
        addToast("Error", "Lesson could not be updated!", ToastTypes.danger);
      })
      .then(() => {
        setIsSavingLesson(false);
      });
  };

  // Upload cover media.
  async function uploadCoverMedia(lesson, updateLesson = (e) => {}) {
    // Check if file is video file
    if (content) {
      // Upload cover media
      CourseService.uploadLessonCoverMedia(
        community.id,
        course.id,
        section.id,
        lesson.id,
        content,
        (progress) => {
          setCoverMediaUpload(progress);
        }
      )
        .then(({ lesson }) => {
          updateLesson(lesson);
        })
        .catch((error) => {
          console.error(error);
          addToast(
            "Error",
            "Lesson cover media could not be uploaded!",
            ToastTypes.danger
          );
        })
        .then(() => {
          setCoverMediaUpload(0);
        });
    } else if (lesson.coverMedia && contentUrl == null) {
      // Delete cover media
      CourseService.uploadLessonCoverMedia(
        community.id,
        course.id,
        section.id,
        lesson.id,
        undefined,
        (progress) => {
          setCoverMediaUpload(progress);
        }
      )
        .then(({ lesson }) => {
          updateLesson(lesson);
        })
        .catch((error) => {
          console.error(error);
          addToast(
            "Error",
            "Lesson cover media could not be uploaded!",
            ToastTypes.danger
          );
        })
        .then(() => {
          setCoverMediaUpload(0);
        });
    } else {
      updateLesson(lesson);
    }
  }

  // Publish lesson
  const publishLesson = (e) => {
    setIsPublishing(true);
    const Payload = {
      ...lesson,
      state: isPublished ? LessonState.draft : LessonState.published,
    };
    CourseService.createLesson(
      community.id,
      course.id,
      section.id,
      Payload,
      lesson.id
    )
      .then(({ lesson }) => {
        updateLesson(lesson);
        addToast(
          "Success",
          "Lesson published successfully!",
          ToastTypes.success
        );
      })
      .catch((error) => {
        console.error(error);
        addToast("Error", "Lesson could not be published!", ToastTypes.danger);
      })
      .then(() => {
        setIsPublishing(false);
      });
  };

  //UPDATE EXISTING LESSON IN SECTION
  function updateLesson(lesson) {
    if (!lesson) {
      console.error("Lesson is not defined");
    } else if (!section) {
      console.error("Section is not defined");
    } else {
      const lessons = section.lessons.map((l) => {
        if (l.id === lesson.id) {
          return lesson;
        }
        return l;
      });
      updateSection({ ...section, lessons });
    }
  }
  if (isLoading) {
    return (
      <div className="h-full flex-col space-y-2 rounded bg-card px-4 py-2">
        <Loader />
      </div>
    );
  } else if (!Validator.hasValue(lesson)) {
    return (
      <>
        <AlertStrip
          error
          title="No lesson found"
          message="Please select a lesson from the left panel."
          className="bg-card"
        />
      </>
    );
  }

  return (
    <div className="flex h-full flex-col space-y-2 rounded bg-card px-4 py-2">
      <div className="flex place-content-between items-center">
        <Label size="h3" variant="t2">
          {lesson.title}
        </Label>

        <div className="flex items-center space-x-2">
          <TextButton
            label="Save"
            isLoading={IsSavingLesson}
            onClick={(e) => {
              updateLessonDescription(description);
            }}
          />
          {!isPublished && (
            <Button
              label="Publish"
              flat
              onClick={publishLesson}
              isLoading={IsPublishing}
            />
          )}
        </div>
      </div>
      {/* <ContentSection
        setContent={setContent}
        setContentUrl={setContentUrl}
        setCreateContent={setCreateContent}
        createContentUrl={createContent}
        setCre
        content={content}
        contentUrl={contentUrl}
        coverMediaUploadPercent={coverMediaUploadPercent}
      />
      {embedded && (
        <EmbeddedSection
          embedded={embedded}
          embeddedUrl={embeddedUrl}
          coverMediaUploadPercent={coverMediaUploadPercent}
        />
      )}

      {content ? (
        <></>
      ) : (
        <AddContentSection
          content={content}
          setContent={setContent}
          setCreateContent={setCreateContent}
        />
      )} */}
      <VideoSection />

      <Suspense fallback={<></>}>
        <RichTextEditor
          className="noBorder maxHeightInfinite w-full px-2"
          text={description}
          placeholder="Write lesson details here ..."
          setText={setDescription}
        />
      </Suspense>
    </div>
  );

  function AddContentSection({ setContent, setCreateContent }) {
    const [addContentVisible, setAddContentVisible] = useState(false);
    return (
      <div className="theme-border-subtitle-2 flex h-[150px] cursor-pointer flex-col items-center justify-center gap-3 rounded border border-dashed text-secondary-foreground/70">
        <UIcon
          icon="plus"
          className="flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground"
        />
        <ModalForm
          title={"Select Content"}
          visible={addContentVisible}
          setVisible={setAddContentVisible}
          className="w-full max-w-lg"
          button={
            <TextButton
              label="Add content"
              className="mx-2 outline outline-1"
              onClick={() => setAddContentVisible(true)}
            />
          }>
          <AddLessonContentComponent
            setCreateContent={setCreateContent}
            setContent={setContent}
            setEmbedded={setEmbedded}
          />
        </ModalForm>
      </div>
    );
  }

  function VideoSection() {
    return (
      <div className="z-0 flex flex-col">
        <div className="w-full">
          {content ? (
            <>
              <div className="flex max-h-80 w-full flex-col items-center justify-center rounded bg-background">
                {coverMediaUploadPercent && coverMediaUploadPercent > 0 ? (
                  <>
                    {/* Display upload video progress */}
                    <div className="flex h-64 flex-col place-content-center items-center">
                      <p>Uploading video {coverMediaUploadPercent}%</p>
                    </div>
                  </>
                ) : (
                  <>
                    <video
                      className="max-h-80 w-full cursor-pointer"
                      controls
                      src={URL.createObjectURL(content)}
                      controlsList="nodownload"
                    />
                  </>
                )}
              </div>
              <div className="mt-2 flex h-12 w-full place-content-between items-center space-x-1 rounded border bg-background px-2">
                <div className="flex items-center">
                  {/* Display video in MB up to 1 decimal point */}
                  <div className="flex items-center space-x-2 text-secondary-foreground/80">
                    <UIcon icon="play-alt" className="mt-1" />
                    <p className="word-breaker">{content.name}</p>
                    <p className="theme-bg-disable word-breaker rounded border px-1 text-secondary-foreground/80">
                      {Math.round((content.size / 1024 / 1024) * 10) / 10} MB
                    </p>
                  </div>
                </div>

                <CloseButton
                  hoverable
                  className="bg-primary-light"
                  type="primary"
                  onClick={(e) => {
                    setContent(null);
                  }}
                />
              </div>
            </>
          ) : contentUrl ? (
            <div className="group relative z-0 mt-4 w-full">
              <video
                className="max-h-80 w-full cursor-pointer rounded bg-background"
                controls
                controlsList="nodownload"
                src={contentUrl}
              />

              <div className="absolute -right-4 -top-4 opacity-0 transition-opacity duration-150 ease-linear group-hover:opacity-100">
                <CloseButton
                  hoverable
                  type="primary"
                  className="bg-primary-light"
                  onClick={(e) => {
                    setContentUrl(null);
                  }}
                />
              </div>
            </div>
          ) : (
            <>
              <FileInput
                accept="video/*"
                onChange={(video) => {
                  setContent(video);
                }}>
                <div
                  style={{ aspectRatio: 16 / 9 }}
                  className={cx(
                    "z-0 flex h-[204px] place-content-center items-center rounded",
                    "theme-border-subtitle-2 border border-dashed",
                    "text-smg text-secondary-foreground/70",
                    "mx-auto lg:w-3/5"
                  )}>
                  <I18>Upload video lecture</I18>
                </div>
              </FileInput>
            </>
          )}
        </div>
        <UploadProgressBar percentComplete={coverMediaUploadPercent} />
      </div>
    );
  }
}
